import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Briefcase, Newspaper, MessageSquare, FileText } from 'lucide-react';
import { newsService, adminService, serviceService } from '../../services/api';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    services: 0,
    news: 0,
    contacts: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [servicesRes, newsRes, contactsRes] = await Promise.all([
        serviceService.getAll(),
        newsService.getAll(),
        adminService.contacts.getAll()
      ]);

      setStats({
        services: servicesRes.data.length,
        news: newsRes.data.length,
        contacts: contactsRes.data.length
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    {
      title: '服務類型',
      value: stats.services,
      icon: Briefcase,
      color: '#00b6a5'
    },
    {
      title: '新聞數目',
      value: stats.news,
      icon: Newspaper,
      color: '#c8ff00'
    },
    {
      title: '聯絡表單',
      value: stats.contacts,
      icon: MessageSquare,
      color: '#00b6a5'
    },
    {
      title: '網站內容',
      value: '✓',
      icon: FileText,
      color: '#c8ff00'
    }
  ];

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold" style={{ color: '#00b6a5' }}>儀表板</h1>
        <p className="text-gray-600 mt-2">歡迎使用安芝僱傭中心管理系統</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2" style={{ borderColor: '#00b6a5' }}></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {statCards.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <Card key={index} className="hover:shadow-lg transition-shadow">
                <CardHeader className="flex flex-row items-center justify-between pb-2">
                  <CardTitle className="text-sm font-medium text-gray-600">
                    {stat.title}
                  </CardTitle>
                  <Icon className="h-6 w-6" style={{ color: stat.color }} />
                </CardHeader>
                <CardContent>
                  <div className="text-3xl font-bold" style={{ color: stat.color }}>
                    {stat.value}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}

      <div className="mt-12">
        <Card>
          <CardHeader>
            <CardTitle style={{ color: '#00b6a5' }}>快速開始</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold mb-2">🌐 管理網站內容</h3>
                <p className="text-sm text-gray-600">更新首頁內容、公司資訊及聯絡方式。</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold mb-2">💼 管理服務</h3>
                <p className="text-sm text-gray-600">更新服務價格及服務內容，確保資訊為最新。</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold mb-2">📰 管理新聞</h3>
                <p className="text-sm text-gray-600">發佈最新消息、到港資訊及優惠活動。</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold mb-2">📧 查看聯絡表單</h3>
                <p className="text-sm text-gray-600">查閱及跟進客戶查詢，及時回應客戶需求。</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminDashboard;
